import close from "@self/images/close";
import { noticeFailure, noticeSuccess } from "@self/notices";
import { makeStylesheetLink } from "@self/stylesheet";

export class RemoveFromCart extends HTMLElement {

	shadow: ShadowRoot;

	button: HTMLButtonElement;

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = <button
			type="button"
			className="gct-cart-btn"
			innerHTML={close}
		/> as HTMLButtonElement;

		this.onClick = onClick.bind(this);

		this.shadow.append(this.button, makeStylesheetLink());
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick);
	}
}

async function onClick(this: RemoveFromCart) {
	try {
		this.button.disabled = true;

		const res = await fetch(this.dataset.endpoint!, {
			method: "POST",
			credentials: "include",
		});

		const html = await res.text();
		const newDocument = new DOMParser().parseFromString(html, "text/html");
		document.body.innerHTML = newDocument.body.innerHTML;

		noticeSuccess("Product removed.");
	} catch (error) {
		if (error instanceof TypeError) {
			noticeFailure("Couldn't connect. Are you online?");
		} else {
			noticeFailure("There was an unexpected error.")
		}
	} finally {
		this.button.disabled = false;
	}
}
